import { useFormikContext } from "formik";
import React, { FC, useState } from 'react';
import { DEF_PG_SIZE_WIZARD } from '../../../../constants/maximum-page-size';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { useLocale } from '../../../../contexts/localeContext';
import { TableContextProvider } from '../../../../contexts/table/TableContextProvider';
import { TableColumn } from '../../../../models/table/TableColumn';
import DashboardTable from '../../dashboard-table';
import { WizardStepLayout } from '../../../wizard/wizard-summary-layout';
import { LOCATION_COMMANDS, SITE_COMMANDS, ZONE_COMMANDS } from "../../../../constants/widget-constants";
import { ListData } from "../../../../models/ListData";

interface Props {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
}

const CommandTypeStep: FC<Props> = ({ onBack, onNext, setSideBarStepDescription, }) => {
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();

    const TempColumns: TableColumn[] = [
        {
            heading: "Type",
            accessor: "name",
            isNumeric: false,
            id: 0,
            sortByName: "settingType.nameOriginal",
            sortDirection: "asc",
            active: true,
            translationKey: translate.byKey(TranslationKeys.type),
            isDefault: true,
        }
    ];

    const selectedEntity = {
        'SITE_COMMANDS': translate.byKey(TranslationKeys.site),
        'ZONE_COMMANDS': translate.byKey(TranslationKeys.zone),
        'LOCATION_COMMANDS': translate.byKey(TranslationKeys.door),
    };

    const onLocalNext = (event: any) => {
        if (taskSelected) {
            onNext({ ...event });
            setSideBarStepDescription(selectedEntity[values.filterBy])
        }
    };

    const itemSelected = (selectedItem: any) => {
        if (selectedItem) {
            setTaskSelected(true);
            setFieldValue("filterById", selectedItem.value);
            setFieldValue("filterBy", selectedItem.filterValue);
            setSideBarStepDescription(selectedEntity[selectedItem.filterValue]);
            onNext({});
        }
    };

    const dataMethod = (): Promise<ListData> => {
        const FILTER_BY_OPTIONS = [
            { value: LOCATION_COMMANDS, label: translate.byKey(TranslationKeys.door) },
            { value: SITE_COMMANDS, label: translate.byKey(TranslationKeys.site) },
            { value: ZONE_COMMANDS, label: translate.byKey(TranslationKeys.zone) },
        ];

        return Promise.resolve({
            rows: FILTER_BY_OPTIONS.map((data) => ({
                label: data.label,
                value: data.value,
                name: data.label,
                filterValue: data.value,
            })),
            pagination: {
                maxPageSize: 8,
                pageNumber: 1,
                totalCount: FILTER_BY_OPTIONS.length,
                totalPages: 1,
            },
        });
    };

    return <WizardStepLayout onBack={onBack} onNext={onLocalNext} nextDisabled={!taskSelected}>
        <div className="flex flex-col h-full">
            <div className="mb-3 text-portal-blue-primary-shade2 text-xl font-semibold">{translate.byKey(TranslationKeys.Commands)}</div>
            <div className="flex-1 min-h-0">
                <TableContextProvider
                    useTable
                    dataMethod={dataMethod}
                    tableDescriptor={TempColumns}
                    disableSearch={true}
                    maxPageSize={DEF_PG_SIZE_WIZARD}>
                    <DashboardTable onRowClicked={itemSelected} />
                </TableContextProvider>
            </div>
        </div>
    </WizardStepLayout>
};

export default CommandTypeStep;